import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg } from "@/lib/api";
import { MODES, MODE_HINT } from "@/lib/pricing";

const EMPTY = { name: "", category: "", details: "", price: 0, mode: "radice", cost: 0, cost_mode: "", source: "proprio", supplier: "", kind: "articolo" };

export const ItemDialog = ({ item, sections, onClose, onSaved }) => {
  const api = useApi();
  const [f, setF] = useState(EMPTY);
  useEffect(() => {
    if (item) setF({ ...EMPTY, category: sections[0], ...item });
  }, [item, sections]);
  const save = async () => {
    if (!f.name.trim()) return toast.error("Inserisci il nome");
    const body = { name: f.name, category: f.category, details: f.details, price: +f.price || 0, mode: f.mode, cost: +f.cost || 0, cost_mode: f.cost_mode || f.mode, source: f.source || "proprio", kind: f.kind || "articolo", supplier: f.supplier || "" };
    try {
      if (item.id) await api.put(`/catalog/${item.id}`, body); else await api.post("/catalog", body);
      toast.success("Articolo salvato");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-700 max-w-lg" data-testid="item-dialog">
        <DialogHeader><DialogTitle>{f.id ? "Modifica " : "Nuovo "}{f.kind === "kit" ? "kit" : "articolo"}{f.source === "noleggio" ? " a noleggio" : ""}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5"><Label className="micro-label">Nome</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="item-name-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label className="micro-label">Sezione</Label>
              <Select value={f.category} onValueChange={(v) => setF({ ...f, category: v })}>
                <SelectTrigger data-testid="item-category-select"><SelectValue /></SelectTrigger>
                <SelectContent>{sections.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="space-y-1.5"><Label className="micro-label">{f.source === "noleggio" ? "Prezzo vendita giornaliero €" : "Prezzo giornaliero €"}</Label><Input type="number" min={0} step="any" value={f.price} onChange={(e) => setF({ ...f, price: e.target.value })} className="font-mono" data-testid="item-price-input" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label className="micro-label">{f.source === "noleggio" ? "Costo noleggio €" : "Costo interno €"}</Label><Input type="number" min={0} step="any" value={f.cost} onChange={(e) => setF({ ...f, cost: e.target.value })} className="font-mono" data-testid="item-cost-input" /></div>
            <div className="space-y-1.5"><Label className="micro-label">Provenienza</Label>
              <Select value={f.source} onValueChange={(v) => setF({ ...f, source: v })}>
                <SelectTrigger data-testid="item-source-select"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="proprio">Di proprietà / manodopera</SelectItem><SelectItem value="noleggio">A noleggio da fornitore</SelectItem></SelectContent>
              </Select>
            </div>
          </div>
          {f.source === "noleggio" && <div className="space-y-1.5"><Label className="micro-label">Fornitore</Label><Input value={f.supplier} onChange={(e) => setF({ ...f, supplier: e.target.value })} data-testid="item-supplier-input" /></div>}
          <div className="space-y-1.5"><Label className="micro-label text-cyan-300">Calcolo costo</Label>
            <Select value={f.cost_mode || f.mode} onValueChange={(v) => setF({ ...f, cost_mode: v })}>
              <SelectTrigger data-testid="item-cost-mode-select"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.keys(MODES).map((k) => <SelectItem key={k} value={k}>{MODE_HINT[k].replace("Prezzo", "Costo")}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5"><Label className="micro-label">Calcolo</Label>
            <Select value={f.mode} onValueChange={(v) => setF({ ...f, mode: v })}>
              <SelectTrigger data-testid="item-mode-select"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.keys(MODES).map((k) => <SelectItem key={k} value={k}>{MODE_HINT[k]}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5"><Label className="micro-label">Dettagli (appaiono nel PDF)</Label><Textarea rows={4} value={f.details} onChange={(e) => setF({ ...f, details: e.target.value })} placeholder="n. 2 NX 14-A&#10;n. 2 palo" data-testid="item-details-input" /></div>
        </div>
        <DialogFooter><Button variant="ghost" onClick={onClose}>Annulla</Button><Button onClick={save} data-testid="item-save-btn">Salva</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
